import { MapboxGeoJSONFeature } from "mapbox-gl";

import { EnrichedMultiProject, Project, ProjectData, ProjectState, UploadType, View } from "fond/types";

function getCurrentProjectProp<T extends keyof ProjectData>(state: ProjectState, prop: T): ProjectData[T] {
  return state.projectId != null && state.projects[state.projectId] != null ? state.projects[state.projectId][prop] : null;
}

export function getCurrentProject(state: ProjectState): Project | EnrichedMultiProject | undefined {
  return getCurrentProjectProp(state, "project");
}

export function getCurrentProjectData(state: ProjectState) {
  return getCurrentProjectProp(state, "data");
}

export function getCurrentProjectView(state: ProjectState): View {
  return getCurrentProjectProp(state, "view");
}

export function getCurrentProjectLayerFeatureTotals(state: ProjectState) {
  return getCurrentProjectProp(state, "layerFeatureTotals");
}

export function getCurrentProjectHighlights(state: ProjectState): MapboxGeoJSONFeature[] {
  return getCurrentProjectProp(state, "highlightedFeatures");
}

export function getCurrentProjectUploads(state: ProjectState): { [layerKey: string]: UploadType } {
  return getCurrentProjectProp(state, "uploads");
}
